import eventService from "..";
import { AppEvent } from "../constants";

let microAppData: any = {};

export const getMicroAppData = () => microAppData;

export const setMicroAppData = (data) => {
  microAppData = data;
};

eventService.addListener(AppEvent.UPDATE_MICRO_APP_PROPS, setMicroAppData);
